import global from '@/util/mixin/global'
import listComponent from '@/util/proto/listComponent'

//0、即将到期，1、已到期
const stateIcon = [
  { value: 0, label: 'warning' },
  { value: 1, label: 'error' }
]

export default {
  extends: listComponent,
  mixins:[global],
  data() {
    let cols = []

    return {
      columns: [
        {
          title: '姓名',
          key: 'name',
          minWidth: 260,
          maxWidth:450,
          render:(h,{row}) => {
            return (
              <div style="display: flex; align-items: center;">
                <sl-badge title={row.stateText} style={{'marginRight':'12px'}} status={row.stateIcon} />
                <div style="flex: 1 1 auto;">
                  <div class="tb-list-item-cell">
                    <div class="tb-list-item-cell-l">
                      <span style="font-size:14px;color: rgba(0, 0, 0, 0.65);min-width:42px;display:inline-block;">{row.courierName || '未绑定'}</span>
                      
                      <span class="inline-flex" style="font-size:11px;color:rgba(0,0,0,.55);margin-left:8px;">
                        <Icon style={{'marginRight':'5px'}} type="md-phone-portrait" />
                        <span>{row.courierPhone}</span>
                      </span>
                    </div>

                    <div class="tb-list-item-cell-r">
                        <span style="font-size:11px;color:rgba(0,0,0,.65);">No.{row.carNo}</span>
                    </div>
                  </div>
                  <div class="tb-list-item-cell">
                    <div class="tb-list-item-cell-l light" style="font-size:12px;">{row.insuranceCompanyName}</div>
                    <div class="tb-list-item-cell-r">
                      <span style="font-size:11px;color:rgba(0,0,0,.55);">
                        <Icon custom="i-icon icon-credentials" />
                        {row.carLicenseNo}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )
          }
        },
        {
          minWidth: 260,
          render : (h , {row}) => {
            return (
              <div style="flex: 1 1 auto;">
                <div class="tb-list-item-cell flex">
                  <div class="tb-list-item-cell-l">
                    <span style="font-size:13px;color: rgba(0, 0, 0, 0.65);">{row.insuranceCompanyName}</span>
                    <span style="font-size:11px;color: rgba(0, 0, 0, 0.65);margin-left:8px;">{row.insuranceName || '未知保险方案'}</span>
                  </div>
                  <div class="tb-list-item-cell-r" style="flex: none;">
                    <span class="flex" style="font-size:12px;color:rgba(0,0,0,.6);">推送时间</span>
                  </div>
                </div>
                <div class="tb-list-item-cell">
                  <span class="flex tb-list-item-cell-l" style="font-size:12px;color:rgba(0,0,0,.6);flex:none;">
                    <Icon custom="i-icon icon-insurance" style={{'marginRight':'6px',color:'#52c41a'}} />
                    <span>{row.startDatetimeText} 至 {row.endDatetimeText}</span>
                    <sl-tag color={row.stateIcon} style={{'fontSize':'10px','marginLeft':'8px','opacity':'0.75'}}>{row.stateText}</sl-tag>
                  </span>
                  <span class="tb-list-item-cell-r">
                    {row.pushDatetimeText}
                  </span>
                </div>
              </div>
            )
          }
        },
      ],
      data: [],
      params: {
        courierName: null,
        carNo: null,
        companyId: null,
      },
      loading: false,
    }
  },

  created() {
    this.def = { ...this.params }
    
    this.search()
  },

  methods: {

    search() {
      let params = { search: { ...this.params,isLast:1 }, pageSize: this.page.pageSize, pageNum: this.page.pageNum }
      this.loading = true
      //TODO 
      //if(this.$store.state.auth.userRole == 1){
        //params.search['province'] = this.$store.state.auth.user.orgVO.province
        // params.search['city'] = this.$store.state.auth.user.orgVO.city
        // params.search['area'] = this.$store.state.auth.user.orgVO.area
      //}
      this.$request.insuranceReminders(params).then(resp => {
        this.loading = false
        if (!resp.code) {
          this.data = this.$utils.conv(resp.data.list || [], { 'startDatetime': 'date','endDatetime':'date','pushDatetime':'date','state':'insuranceReminderState','state:stateIcon':stateIcon})
          this.page.total = resp.data.total || 0
        }
      })
    },

   
    reset() {
      this.params = {}
      this.search()
    },

  },
  render(){
    return (
      <sl-page>
        <div class="page-filter">
          <sl-search on-search={this.search} on-reset={this.reset}showCount={4} >
            <sl-search-item label="">
              <i-input v-model={this.params.carNo} placeholder="车辆编号" />
            </sl-search-item>
            <sl-search-item label="">
              <sl-select dict="company" v-model={this.params.companyId} placeholder="企业" />
            </sl-search-item>
            <sl-search-item label="">
              <i-input v-model={this.params.courierName} placeholder="姓名" />
            </sl-search-item>
          </sl-search>
        </div>

        <div class="pg-bd">
          <sl-table showHeader={false} loading={this.loading} page={this.page} columns={this.columns} data={this.data} on-change={this.$tableChange} selectionKey={false}>
          </sl-table>
        </div>
      </sl-page>
    )
  }
}
